import { Box, useMediaQuery } from '@televet/kibble-ui/build/chakra';
import { useConversationsContext } from 'pages/Conversations/context/ConversationsContext';
import { getConversationListWidth } from 'pages/Conversations/utils/styles';
import React, { useEffect, useMemo } from 'react';
import { DeviceSizes } from 'shared/enums/DeviceSizes';
import { TeletriageConversationCenterDrawer } from './components/TeletriageConversationCenterDrawer';
import { TeletriageConversationCenterTrigger } from './components/TeletriageConversationCenterTrigger';
import { useTeletriageUnreadMessages } from './hooks/useTeletriageUnreadMessages';

export const TeletriageConversationCenter = (): JSX.Element => {
  // Styling
  const [isTablet, isDesktop] = useMediaQuery([`(${DeviceSizes.TabletMinWidth})`, `(${DeviceSizes.DesktopMinWidth})`]);
  const containerWidth = useMemo(() => getConversationListWidth({ isDesktop, isTablet }), [isDesktop, isTablet]);

  // Drawer
  const { onTeletriageConversationCenterOpen, isTeletriageConversationCenterOpen } = useConversationsContext();

  // Unread Messages
  const { count, unreadChannelIds } = useTeletriageUnreadMessages();

  useEffect(() => {
    const unread = count ? ` (${count})` : '';
    document.title = `${document.title.replace(/ \(\d+\)$/, '')}${unread}`;
  }, [count]);

  return (
    <Box className="TeletriageConversationCenter" position="absolute" bottom={0} w={containerWidth}>
      {!isTeletriageConversationCenterOpen && (
        <TeletriageConversationCenterTrigger unreadMessagesCount={count} onClick={onTeletriageConversationCenterOpen} />
      )}
      <TeletriageConversationCenterDrawer
        containerWidth={containerWidth}
        unreadMessagesCount={count}
        unreadChannelIds={unreadChannelIds}
      />
    </Box>
  );
};
